import { render, staticRenderFns } from "./ExportDataStep2.vue?vue&type=template&id=80f49e66"
import script from "./ExportDataStep2.vue?vue&type=script&lang=js"
export * from "./ExportDataStep2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports